module.exports = __webpack_public_path__ + "img/mic-sprite.49d8333e.svg";